const isProduction = process.env.NODE_ENV === 'production'
const { version } = require('./package.json')

module.exports = {
  transpileDependencies: ['vuetify'],
  publicPath: process.env.VUE_APP_PUBLIC_PATH || (isProduction ? '/estadofuerza/' : '/'),
  chainWebpack: (config) => {
    config.plugin('define').tap((definitions) => {
      definitions[0] = definitions[0] || {}
      definitions[0]['process.env.VUE_APP_VERSION'] = JSON.stringify(version)
      return definitions
    })
  },
}
